import { createSlice } from "@reduxjs/toolkit";
import { GetProfileDetails } from "./profileActions";

const initialState = {
    profileDetails: {},
    loading: false,
    openProfileDetailModal: false,
    error: null,
};

const profileDetailsSlice = createSlice({
    name: 'profileDetails',
    initialState,
    reducers: {
        openProfileModal: (state) => {
            state.openProfileDetailModal = true;
        },
        closeProfileModal: (state) => {
            state.openProfileDetailModal = false;
        },
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(GetProfileDetails.pending, (state: any) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetProfileDetails.fulfilled, (state: any, action: any) => {
                state.loading = false;
                state.profileDetails = action.payload.data;
            })
            .addCase(GetProfileDetails.rejected, (state: any, action: any) => {
                state.loading = false;
                state.error = action.payload ? action.payload.error : "Failed to load properties";
            });
    },
});


export const { openProfileModal, closeProfileModal } = profileDetailsSlice.actions;
export const profileDetails = profileDetailsSlice.reducer;
